// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vhf-frequency-position-report-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vhf-frequency-position-report-procedures/vhf-frequency-position-report-procedures.js';

mount([g0]);
